import { find, isEmpty } from "lodash";
import React from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import QualysContainerSecurityCredentialsForm from "./QualysContainerSecurityCredentialsForm";
import QualysContainerSecurityMappingForm, {
  QUALYS_CONTAINER_SECURITY_TYPES,
} from "./QualysContainerSecurityMappingForm";

const QualysContainerSecurityConfigListing = (props) => {
  const extraColumns = [
    {
      dataIndex: "type",
      title: "Type",
      render: (type) =>
        find(QUALYS_CONTAINER_SECURITY_TYPES, { value: type })?.label,
      width: 200,
    },
    {
      dataIndex: "imageName",
      title: "Images",
      render: (images, record) =>
        record.type === "images" && isEmpty(images)
          ? "All"
          : columnRenderArrayData(images),
      width: 200,
    },
    {
      dataIndex: "containerName",
      title: "Container",
      render: (container, record) =>
        record.type === "containers" && isEmpty(container)
          ? "All"
          : columnRenderArrayData(container),
      width: 200,
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={QualysContainerSecurityMappingForm}
      extraColumns={extraColumns}
      CredentialsForm={QualysContainerSecurityCredentialsForm}
    />
  );
};

export default QualysContainerSecurityConfigListing;
